import { defineMessages } from 'react-intl';

const messages = defineMessages({
  descriptionLabel: {
    id: 'modules.CatalogV2.pages.Product.components.Form.descriptionLabel',
    defaultMessage: 'Descrição',
  },
  descriptionPlaceholder: {
    id: 'modules.CatalogV2.pages.Product.components.Form.descriptionPlaceholder',
    defaultMessage: 'Digite a descrição do produto',
  },
  salesFormatLabel: {
    id: 'modules.CatalogV2.pages.Product.components.Form.salesFormatLabel',
    defaultMessage: 'Formato de venda',
  },
  minimumPurchaseAmountLabel: {
    id: 'modules.CatalogV2.pages.Product.components.Form.minimumPurchaseAmountLabel',
    defaultMessage: 'Pedido mínimo',
  },
  minimumPurchaseAmountHelperText: {
    id: 'modules.CatalogV2.pages.Product.components.Form.minimumPurchaseAmountHelperText',
    defaultMessage: `{salesFormat, select,
      box {Em número de caixas}
      other {}
    }`,
  },
  increaseAmountLabel: {
    id: 'modules.CatalogV2.pages.Product.components.Form.increaseAmountLabel',
    defaultMessage: 'Quantidade de itens por caixa',
  },
  fullPriceLabel: {
    id: 'modules.CatalogV2.pages.Product.components.Form.fullPriceLabel',
    defaultMessage: 'Preço da unidade',
  },
  boxPriceLabel: {
    id: 'modules.CatalogV2.pages.Product.components.Form.boxPriceLabel',
    defaultMessage: 'Preço por caixa:',
  },
  discountPercentageLabel: {
    id: 'modules.CatalogV2.pages.Product.components.Form.discountPercentageLabel',
    defaultMessage: 'Desconto no produto',
  },
  discountPercentageHelperText: {
    id: 'modules.CatalogV2.pages.Product.components.Form.discountPercentageHelperText',
    defaultMessage: 'Porcentagem de desconto no preço final do produto',
  },
  appliedDiscountTip: {
    id: 'modules.CatalogV2.pages.Product.components.Form.appliedDiscountTip',
    defaultMessage: 'Desconto aplicado:',
  },
  priceWithDiscountTip: {
    id: 'modules.CatalogV2.pages.Product.components.Form.priceWithDiscountTip',
    defaultMessage: 'Preço da unidade com desconto:',
  },
  suggestedRetailPriceLabel: {
    id: 'modules.CatalogV2.pages.Product.components.Form.suggestedRetailPriceLabel',
    defaultMessage: 'Preço de revenda sugerido',
  },
  suggestedRetailPriceHelperText: {
    id: 'modules.CatalogV2.pages.Product.components.Form.suggestedRetailPriceHelperText',
    defaultMessage: `{salesFormat, select,
      box {Em valor unitário}
      other {}
    }`,
  },
  publishedToggleLabel: {
    id: 'modules.CatalogV2.pages.Product.components.Form.publishedToggle',
    defaultMessage: 'Publicar produto',
  },
  inStockToggleLabel: {
    id: 'modules.CatalogV2.pages.Product.components.Form.inStockToggleLabel',
    defaultMessage: 'Produto em estoque',
  },
  contactInfo: {
    id: 'modules.CatalogV2.pages.Product.components.contactInfo',
    defaultMessage:
      'Para modificar informações adicionais dos seus produtos entre em <a>contato com nosso time de suporte aqui</a>',
  },
  whatsappDefaultMessage: {
    id: 'modules.CatalogV2.pages.Product.components.whatsappDefaultMessage',
    defaultMessage:
      'Olá, sou fornecedor e preciso de ajuda para editar meus produtos no portal.',
  },
  buttonLabel: {
    id: 'modules.CatalogV2.pages.Product.components.Form.buttonLabel',
    defaultMessage: 'Modificar Produto',
  },
  salesFormatRadioLabelByOption: {
    id: 'modules.CatalogV2.pages.Product.components.Form.salesFormatRadioLabelByOption',
    defaultMessage: `{option, select,
      unit {Unidade}
      box {Caixa}
      other {}
    }`,
  },
  requiredFieldError: {
    id: 'modules.CatalogV2.pages.Product.components.Form.requiredFieldError',
    defaultMessage: 'Campo obrigatório.',
  },
  integerFieldError: {
    id: 'modules.CatalogV2.pages.Product.components.Form.integerFieldError',
    defaultMessage: 'Número deve ser inteiro.',
  },
  minNumberFieldError: {
    id: 'modules.CatalogV2.pages.Product.components.Form.minNumberFieldError',
    defaultMessage: 'Número deve ser maior ou igual a {min}.',
  },
  moreThanNumberFieldError: {
    id: 'modules.CatalogV2.pages.Product.components.Form.moreThanNumberFieldError',
    defaultMessage: 'Número deve ser maior que {more}.',
  },
  maxNumberFieldError: {
    id: 'modules.CatalogV2.pages.Product.components.Form.maxNumberFieldError',
    defaultMessage: 'Número deve ser menor ou igual a {max}.',
  },
});

export default messages;
